const tracking = {
    init() {
        if (typeof window.Chronoto.routes.t !== 'undefined') {
            const listings = document.querySelectorAll('.js-metrics-listing');
            listings.forEach((element) => {
                if (element.hasAttribute('data-lid') && element.getAttribute('data-lid')) {
                    window.Chronoto.t.l.push(element.getAttribute('data-lid'));
                }
            });
            this.track(window.Chronoto.t);
        }
    },

    track(data) {
        $.post(window.Chronoto.routes.t, data);
    },
};

export default tracking;
